import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useClassroomCredentials } from '../ClassroomContext';
import { StudentEnrollmentStatus } from '../ClassroomLoader';
import { SignInDialog } from './SignInDialog';

/**
 * This component is responsible for checking if the student is authorized to view the lesson
 * and enrolled in the classroom. If not, it will show a dialog to sign in.
 */

export function GoogleClassroomStudentValidator() {
  const [signInDialogOpen, setSignInDialogOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const urlParams = new URLSearchParams(window.location.search);
  const googleClassroomId = urlParams.get('google_classroom_id');
  const provider = urlParams.get('provider');

  const classroomCredentials = useClassroomCredentials();

  const studentUnauthorized = classroomCredentials?.status === StudentEnrollmentStatus.Unauthorized;
  const studentEnrolled = classroomCredentials?.status === StudentEnrollmentStatus.Enrolled;
  const studentNotEnrolled = classroomCredentials?.status === StudentEnrollmentStatus.NotEnrolled;

  const studentNote = studentEnrolled
    ? 'You are enrolled in this classroom and your work will be shown to your teacher.'
    : 'You are not enrolled in this classroom and your work will not be shown to your teacher.';

  useEffect(() => {
    if (studentUnauthorized) {
      setSignInDialogOpen(true);
    }
    if (studentNotEnrolled || studentEnrolled) {
      enqueueSnackbar(studentNote);
    }
  }, [setSignInDialogOpen, studentUnauthorized, studentNotEnrolled, studentEnrolled, enqueueSnackbar, studentNote]);

  return (
    <SignInDialog
      open={signInDialogOpen && studentUnauthorized}
      classroomId={classroomCredentials?.classroomId || ''}
      googleClassroomId={googleClassroomId || ''}
      provider={provider || ''}
    />
  );
}
